/**
 * ReportTransaction entity class
 *
 * Аналог ReportFinancial, но с url /report/transaction/*
 */
import moment from 'moment/moment'
import FileSaver from 'file-saver'

/* @ngInject */
export default function ReportTransactionFactory ($http, $injector, Report, onOffMixin, alertLiteSvc) {
  function ReportTransaction () {
    var obj = Report.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportTransaction.prototype = Object.create(Report.prototype)
  ReportTransaction.prototype.constructor = ReportTransaction

  Object.assign(ReportTransaction.prototype, {
    _fields: {
      reportId: Number,
      name: String,
      status: String,
      createdTime: moment,
      createdBy: String,
      organizations: [],
      deleted: Boolean,
      fromDate: moment,
      toDate: moment,
      reportDetails:
        {
          from: moment,
          to: moment,
          reportName: String,
          periodCount: String,
          periodType: String,
          createdBy: String,
          purchaseItemCategories: [String],
          purchaseItemStatuses: [String],
          paymentSystemTypes: [String],
          organizations: [{ name: String, organizationId: Number }],
          users: [String],
          convertedAfterTrialDays: Number,
          firstActivation: Boolean,
          autoPay: Boolean,
          reportType: String,
          withoutTrial: Boolean,
          subscriptionsFilter: {
            dailySubscriptionLength: { from: Number, to: Number },
            monthlySubscriptionLength: { from: Number, to: Number },
            names: [String]
          }
        }
    },

    _urlTemplate: 'api/report/transactional/{{::reportId}}',
    _publicUrlTemplate: '/report/transactional/{{::reportId}}',

    _download (type) {
      $http.get(this._url + '\\download', {
        responseType: 'blob'
      }).then((response) => {
        FileSaver.saveAs(response.data, this.reportId + ' ' + moment(this.createdTime).format('DD-MM-YYYY HH-mm') + '.zip')
      })
    }
  }, onOffMixin)

  ReportTransaction.getSubscriptions = function () {
    return $http.get('/report/transaction/extra')
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  ReportTransaction.search = function (url, params) {
    return $http.post(url, { ...params })
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  ReportTransaction.extra = {
    subscriptions: [{ id: Number, name: String }]
  }

  Object.assign(ReportTransaction, Report)
  ReportTransaction._name = 'ReportTransaction'
  ReportTransaction.init()

  return ReportTransaction
}
